import { useEffect, useState, useRef } from 'react';
import { io, Socket } from 'socket.io-client';

const WS_URL = import.meta.env.VITE_WS_URL || 'http://localhost:3001';

export function useWebSocket() {
    const [socket, setSocket] = useState<Socket | null>(null);
    const [connected, setConnected] = useState(false);
    const [sensorData, setSensorData] = useState<any>(null);
    const [emergencyAlert, setEmergencyAlert] = useState<any>(null);

    useEffect(() => {
        const socketInstance = io(WS_URL, {
            transports: ['websocket', 'polling'],
        });

        socketInstance.on('connect', () => {
            console.log('✅ WebSocket connected');
            setConnected(true);
        });

        socketInstance.on('disconnect', () => {
            console.log('❌ WebSocket disconnected');
            setConnected(false);
        });

        socketInstance.on('sensor-update', (data) => {
            setSensorData(data);
        });

        socketInstance.on('emergency-alert', (alert) => {
            setEmergencyAlert(alert);
        });

        setSocket(socketInstance);

        return () => {
            socketInstance.disconnect();
        };
    }, []);

    const subscribeToDevice = (deviceId: string) => {
        if (socket) {
            socket.emit('subscribe-device', deviceId);
        }
    };

    return {
        socket,
        connected,
        sensorData,
        emergencyAlert,
        subscribeToDevice,
    };
}
